import template from './formErrorsSummary.html';
import controller from './formErrorsSummary.controller';
import './formErrorsSummary.scss';

let formErrorsSummaryComponent = {
  restrict: 'E',
  bindings: {
    errors: '<'
  },
  template,
  controller
};

export default formErrorsSummaryComponent;



// WEBPACK FOOTER //
// ./client/app/components/formErrorsSummary/formErrorsSummary.component.js